import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { getRuleConfig } from 'helpers/rulesHelper';
import CategoriesFilter from 'components/list/Filters/types/CategoriesFilter';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import validations from 'helpers/forms/validations';

const StyledInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

class CategoryLimitRule extends React.Component {
    componentDidMount() {
        const {
            initialize,
            type,
            value,
        } = this.props;

        const initialState = {};

        const config = getRuleConfig(utils.firstCharToLowerCase(type)).config;

        utils.each(config, (configValue, property) => {
            initialState[property] = value[property] || null;
        });

        initialize(initialState);
    }

    componentDidUpdate() {
        const {
            formValues,
            onUpdate,
        } = this.props;

        return onUpdate(formValues);
    }

    render() {
        const { translate } = this.props;

        return (
            <StyledInputWrapper>
                <Field
                    component={ CategoriesFilter }
                    name='value.category_id'
                    validate={ validations.required }
                />
                <Field
                    component={ RenderTextInputField }
                    label={ translate('resources.discounts.fields.limit') }
                    name='value.limit'
                    validate={ [
                        validations.required,
                        validations.number,
                    ] }
                />
            </StyledInputWrapper>
        );
    }
}

CategoryLimitRule.propTypes = {
    formValues: PropTypes.shape({
        value: PropTypes.shape({
            category_id: PropTypes.arrayOf(PropTypes.number),
            limit: PropTypes.string,
        }),
    }),
    initialize: PropTypes.func.isRequired,
    onUpdate: PropTypes.func,
    translate: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.shape({
        value: PropTypes.shape({
            category_id: PropTypes.arrayOf(PropTypes.number),
            limit: PropTypes.string,
        }),
    }),
};

const mapStateToProps = (state, props) => {
    const {
        id,
        type,
    } = props;

    const form = `${ type }-${ id }`;

    return {
        form: form,
        formValues: getFormValues(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(mapStateToProps, null),
    reduxForm(),
);

export default enhance(CategoryLimitRule);



// WEBPACK FOOTER //
// ./src/pages/discounts/rules/types/CategoryLimitRule.js